export default "__VITE_PUBLIC_ASSET__17fce4b9__"